import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FlaskConical, Upload } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import QADashboardPage from '@/pages/QADashboardPage';
import SandboxPage from '@/pages/SandboxPage';
import SiafoImportPage from '@/pages/SiafoImportPage';
import { useAuth } from '@/contexts/AuthContext';

const FerramentasDevPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isAdmin } = useAuth();
  const defaultTab = searchParams.get('tab') || 'qa-dashboard';

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div className="h-full flex flex-col gap-4 overflow-auto">
      <Tabs value={defaultTab} onValueChange={handleTabChange} className="flex-1 flex flex-col min-h-0">
        <TabsList className="self-start">
          <TabsTrigger value="qa-dashboard" className="gap-2 text-xs sm:text-sm">
            <FlaskConical className="h-4 w-4" />
            QA Dashboard
          </TabsTrigger>
          {isAdmin && (
            <TabsTrigger value="sandbox" className="gap-2 text-xs sm:text-sm">
              <FlaskConical className="h-4 w-4" />
              Sandbox de Testes
            </TabsTrigger>
          )}
          {isAdmin && (
            <TabsTrigger value="siafo-import" className="gap-2 text-xs sm:text-sm">
              <Upload className="h-4 w-4" />
              Import SIAFO
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="qa-dashboard" className="flex-1 min-h-0 mt-4">
          <QADashboardPage embedded />
        </TabsContent>

        {/* Sandbox e Import SIAFO: restritos a perfil admin */}
        {isAdmin && (
          <TabsContent value="sandbox" className="flex-1 min-h-0 mt-4">
            <SandboxPage embedded />
          </TabsContent>
        )}

        {isAdmin && (
          <TabsContent value="siafo-import" className="flex-1 min-h-0 mt-4">
            <SiafoImportPage embedded />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
};

export default FerramentasDevPage;
